import { render, staticRenderFns } from "./trainingArea.vue?vue&type=template&id=7c6e3c89"
import script from "./trainingArea.vue?vue&type=script&lang=js"
export * from "./trainingArea.vue?vue&type=script&lang=js"
import style0 from "./trainingArea.vue?vue&type=style&index=0&id=7c6e3c89&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports